<template>

  <!-- Clappr Player -->
  <div
    class="clappr-player">

    <div
      ref="player"
      class="clappr-player__player"/>

  </div>

</template>

<script>

  export default {
    name: 'clappr-player',
    props: {
      source: {
        type: String,
        required: true,
      },
      width: {
        type: String,
        default: '100%',
      },
      height: {
        type: String,
        default: '100%',
      },
      poster: {
        type: String,
        default: undefined,
      },
      autoplay: {
        type: Boolean,
        default: false,
      },
      mute: {
        type: Boolean,
        default: false,
      },
      loop: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        player: null,
      };
    },
    methods: {
      async init() {

        if (this.player)
          return;

        const {Player} = require('clappr');

        this.player = new Player({
          parent: this.$refs.player,
          poster: this.poster,
          source: this.source,
          width: this.width,
          height: this.height,
          autoPlay: this.autoplay,
          baseUrl: 'vendor/clappr',
          mute: this.mute,
          loop: this.loop,
        });

        this.player.configure({
          autoPlay: true,
        });

        if (!this.mute)
          this.player.setVolume(30);
      },
      destroy() {

        if (!this.player)
          return;

        this.player.destroy();
        this.player = null;
      },
    },
    mounted() {

      this.init();
    },
    beforeDestroy() {

      this.destroy();
    },
  };

</script>

<style lang="scss">

  .clappr-player {

    &__player{
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
    }

    .player-poster[data-poster] .play-wrapper[data-poster] {
      height: 9%;
    }
  }

</style>

